// extracted by mini-css-extract-plugin
module.exports = {"shop-list-wrapper":"ShopListWrapper_shop-list-wrapper__sPVHo","shop-list-wrapper__inner":"ShopListWrapper_shop-list-wrapper__inner__csGH2"};